import {
  FilterType,
  buildBudgetEmployeesDatatableFilter,
  useBudgetEmployeesDatatable,
} from 'generated/resources/datatable.graphql'
import { EmployeesTeamsQuery } from 'generated/resources/graphql'
import { capitalize } from 'lodash'

import i18n from 'modules/core/lib/i18n'

type TeamsTeam = EmployeesTeamsQuery['teams']['teams'][number]

interface Props {
  source: ReturnType<typeof useBudgetEmployeesDatatable>
  teams: TeamsTeam[]
}

const TeamFilter = ({ source, teams }: Props) => {
  const options = teams.map((team) => {
    return {
      value: team.id,
      label: team.name,
    }
  })

  return buildBudgetEmployeesDatatableFilter(source, {
    path: 'accessTeam',
    identifier: 'budgetMovements.accessTeam',
    type: FilterType.Id,
    title: capitalize(i18n.t('common.team')),
    categories: [
      {
        kind: 'MultipleChoice',
        operation: 'in',
        options,
      },
    ],
    default: true,
  })
}

export default TeamFilter
